/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RollbackElectronMapperItem
 */
export interface RollbackElectronMapperItem {
    /**
     * 
     * @type {string}
     * @memberof RollbackElectronMapperItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RollbackElectronMapperItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RollbackElectronMapperItem
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof RollbackElectronMapperItem
     */
    gameId?: string;
}

/**
 * Check if a given object implements the RollbackElectronMapperItem interface.
 */
export function instanceOfRollbackElectronMapperItem(value: object): value is RollbackElectronMapperItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function RollbackElectronMapperItemFromJSON(json: any): RollbackElectronMapperItem {
    return RollbackElectronMapperItemFromJSONTyped(json, false);
}

export function RollbackElectronMapperItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RollbackElectronMapperItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'source': json['source'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
    };
}

export function RollbackElectronMapperItemToJSON(json: any): RollbackElectronMapperItem {
    return RollbackElectronMapperItemToJSONTyped(json, false);
}

export function RollbackElectronMapperItemToJSONTyped(value?: RollbackElectronMapperItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'source': value['source'],
        'gameId': value['gameId'],
    };
}

